import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toolbar from '../toolbar/Toolbar';
import {
  getFillSize,
  GetActivePage,
  isImageInChange,
  checkMinimumDPI,
  isFlyleaf,
  getFitSize,
  getEditorRatio,
} from '../../redux/helpers';
import {
  moveImage,
  setRotateImage,
  resetAllTransformations,
  setZoom,
  removeTextureImage,
  fitImage,
  removeDPIOverlay,
  dpiResolution,
  changeFillImageSize,

} from '../../redux/actions/entities/placeholders';
import {
  fill,
  fit,
  maximumDrag,
} from '../../redux/helpers/canvas';
import { imageChange } from '../../redux/actions/ui/imageChange';
import {
  removeImage,
  removeChangedImage,
  removeImageFromFlyLeaf,
} from '../../redux/actions/entities/pages';
import Texture from '../texture/Texture';
import SvgIcon from '../icons/svg-icon/SvgIcon';
import { saveState } from '../../redux/actions/entities/io';
import {
  setImageToCenter,
  getEditorPlaceholderSizes,
  getImageOriginalSizes } from '../../redux/helpers/pages';
import {
  calculateStyle,
  calculateBorderStyle,
  calculcatePlaceholderStyle } from './../../helpers/canvasHelpers';

class Canvas extends Component {
  static contextTypes = {
    redux: React.PropTypes.object,
  }
  constructor(args) {
    super(...args);

    this.dragActions = {
      mouseMove: {
        x: 0,
        y: 0,
      },
      startPosition: {
        x: 0,
        y: 0,
      },
      dragPosition: {
        x: 0,
        y: 0,
      },
    };

    this.dragStartX = 0;
    this.dragStartY = 0;

    this.draggedCanvas = 0.0;
    this.thumbnailRatio = 1;
    this.state = {
      mousePressed: false,
      drag: false,
      visibleOverlay: false,
      targetId: 0,
      isChange: false,
      imagesLoaded: false,
    };
    this.setTimeout = null;
    this.startRendering = this.startRendering.bind(this);
    this.stopRendering = this.stopRendering.bind(this);
    this.images = [];
    this.imagesArray = [];
    this.runOnce = false;
  }

  componentWillReceiveProps(nextProps) {
    const ifIsNormalBook = !this.state.imagesLoaded && nextProps.imagesLoaded === 'loaded' && nextProps.bookProperties.autofill === false;
    const ifIsAutofill = !this.state.imagesLoaded && nextProps.imagesLoaded === 'loaded' && nextProps.autofillFinished && nextProps.bookProperties.autofill;
    if ((ifIsAutofill || ifIsNormalBook) && !this.runOnce) {
      Object.values(nextProps.images.byId).filter((element) => {
        if (element.mediumThumbnail) {
          this.imagesArray.push(element.mediumThumbnail);
        }
      });

      if (!this.state.imagesLoaded) {
        Promise.all(this.loadImages(this.imagesArray)).then(() => {
          this.setState({
            imagesLoaded: true,
          });
        });
      }
      this.runOnce = true;
    }
  }


  shouldComponentUpdate(nextProps) {
    const isAutofillFinishedOrNormalBook = (nextProps.convertFinished && nextProps.imagesLoaded === 'loaded') || (nextProps.autofillFinished && nextProps.bookProperties.autofill) || !nextProps.bookProperties.autofill;

    if (isAutofillFinishedOrNormalBook) {
      return true;
    }

    return false;
  }


  setImageToCanvas(canvasNode, placeholderId) {
    const context = canvasNode.getContext('2d');
    const url = canvasNode.getAttribute('data-image-url');
    const originalImageWidth = canvasNode.getAttribute('data-imagewidth');
    const isChanged = canvasNode.getAttribute('data-isChanged');

    if (!this.props.layoutplaceholders[placeholderId]) {
      return;
    }

    const {
      scaleX,
      scaleY,
      moveX,
      moveY,
      isFit,
      fillSizes,
    } = this.props.layoutplaceholders[placeholderId].transformations;

    let { imageRatio } = this.props.layoutplaceholders[placeholderId];
    const placeholderImage = this.props.layoutplaceholders[placeholderId].imageObject;

    const rotate = this.props.layoutplaceholders[placeholderId] ? (this.props.layoutplaceholders[placeholderId].transformations.rotate) * Math.PI / 180 : 0;
    const originalPlaceholderWidth = this.props.layoutplaceholders[placeholderId].width;
    if (url && !isChanged) {
      if (Object.keys(this.images).length > 0) {
        const imageObject = Object.values(this.images).find(element => element.src === url);
        context.clearRect(0, 0, canvasNode.width, canvasNode.height);

        if (imageObject) {
          if (rotate === 1.5707963267948966 || rotate === 4.71238898038469) {
            imageRatio = fillSizes.width / placeholderImage.originalHeight;
          }

          this.drawFillImage(context, imageRatio, rotate, imageObject, canvasNode, scaleX, scaleY, moveX / imageRatio, moveY / imageRatio, isFit, originalPlaceholderWidth, originalImageWidth, placeholderId);
        }
      }
    } else {
      context.clearRect(0, 0, canvasNode.width, canvasNode.height);
    }
  }


  getIcons(texture, pageId) {
    const { id: placeholderId, image: placeholderImageId } = texture;
    const {
      isChange, layoutplaceholders, pages, lang, images,
    } = this.props;
    const layoutObject = layoutplaceholders[placeholderId];

    const {
      transformations,
      image,
      DPI,
      width,
      height,
      isChanged,
    } = layoutObject;

    const defaultSize = {
      height: 16,
      width: 16,
    };

    const activePage = GetActivePage(pages);
    const { bookSizes } = this.props.bookProperties;

    return [
      {
        name: SvgIcon,
        title: 'Restore image',
        props: {
          width: defaultSize.width,
          height: defaultSize.height,
          path: 'M13 3H3v10h10zM1 1h2V0H0v3h1zm12-1v1h2v2h1V0zM1 13H0v3h3v-1H1zm14 2h-2v1h3v-3h-1z',
          onAction: () => {
            if (!layoutObject.imageObject || transformations.isFit) {
              return;
            }
            this.startRendering();
            this.setDebounce();
            const coverRatio = this.props.bookProperties.cover.coverSizes.hasOwnProperty('heightInPx') ? this.props.bookProperties.cover.coverSizes.heightInPx / this.props.bookProperties.dimensions.layoutHeight : 1;
            const center = setImageToCenter(layoutplaceholders, placeholderId, images.byId, bookSizes, null, coverRatio, activePage.isCover);
            this.props.dispatch(resetAllTransformations(placeholderId, center));
          },
        },
      },
      {
        name: SvgIcon,
        title: 'Zoom In',
        props: {
          width: defaultSize.width,
          height: defaultSize.height,
          path: 'M7 4H6v2H4v1h2v2h1V7h2V6H7zm8.71 10.29l-4-4a6.52 6.52 0 1 0-1.41 1.41l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0-.01-1.41zm-5.61-3.64a5.52 5.52 0 1 1 .55-.55 7.14 7.14 0 0 1-.55.55z',
          onAction: () => {
            if (!layoutplaceholders[placeholderId].imageObject || transformations.isFit) {
              return;
            }

            this.startRendering();
            this.setDebounce();
            this.props.dispatch(setZoom(placeholderId, true));
            if (DPI.isSmall && DPI.isClicked) {
              this.props.dispatch(removeDPIOverlay(placeholderId, false));
              this.props.dispatch(dpiResolution(placeholderId, false));
            }
          },
        },
      },
      {
        name: SvgIcon,
        title: 'Zoom Out',
        props: {
          width: defaultSize.width,
          height: defaultSize.height,
          path: 'M4 7h5V6H4zm11.71 7.29l-4-4a6.52 6.52 0 1 0-1.41 1.41l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0-.01-1.41zm-5.61-3.64a5.52 5.52 0 1 1 .55-.55 7.14 7.14 0 0 1-.55.55z',
          onAction: () => {
            if (!layoutplaceholders[placeholderId].imageObject || transformations.isFit) {
              return;
            }

            this.startRendering();
            this.setDebounce();
            this.props.dispatch(setZoom(placeholderId, false));
            if (DPI.isSmall && DPI.isClicked) {
              this.props.dispatch(removeDPIOverlay(placeholderId, false));
              this.props.dispatch(dpiResolution(placeholderId, false));
            }
          },
        },
      },
      {
        name: SvgIcon,
        title: 'Rotate image',
        props: {
          width: defaultSize.width,
          height: 25,
          path: 'M8 15a.5.5 0 1 0 .5.5.5.5 0 0 0-.5-.5zm7.07-9.83V.93l-1.41 1.41A8 8 0 0 0 2.34 13.66a.51.51 0 0 0 .71 0 .5.5 0 0 0 0-.71 6.5 6.5 0 0 1 9.19-9.19l-1.41 1.41zm-5.26 9.59a.5.5 0 0 0 .26 1 .49.49 0 0 0 .35-.61.5.5 0 0 0-.61-.39zm-3.62 0a.5.5 0 0 0-.61.36.49.49 0 0 0 .35.61.5.5 0 0 0 .26-1zm-1.69-.7a.5.5 0 0 0-.5.87.5.5 0 0 0 .5-.87zm10.25-2.74a.51.51 0 0 0-.69.18.5.5 0 0 0 .87.5.5.5 0 0 0-.18-.68zm.62-1.86a.5.5 0 1 0-.25 1 .49.49 0 0 0 .61-.35.5.5 0 0 0-.36-.65zm.13-2A.5.5 0 1 0 16 8a.5.5 0 0 0-.5-.5zm-4 6.56a.5.5 0 0 0 .5.87.5.5 0 0 0-.5-.87zM13 13a.5.5 0 0 0 0 .71.5.5 0 0 0 .71-.71.5.5 0 0 0-.71 0z',
          onAction: () => {
            if (!layoutplaceholders[placeholderId].imageObject || transformations.isFit) {
              return;
            }
            this.startRendering();
            this.setDebounce();
            this.props.dispatch(setRotateImage(placeholderId, false, transformations.rotate + 90));

            const placeholdersSize = getEditorPlaceholderSizes(layoutplaceholders, placeholderId, bookSizes);
            const origImageSize = getImageOriginalSizes(layoutplaceholders, placeholderId, images.byId, activePage.activePage);
            const fillSize = getFillSize(placeholdersSize, origImageSize, bookSizes, transformations.rotate + 90);

            this.props.dispatch(changeFillImageSize(fillSize, placeholderId, transformations.rotate));
          },
        },
      },
      {
        name: SvgIcon,
        title: 'Delete image',
        props: {
          width: 13,
          height: defaultSize.height,
          path: 'M10 2V1a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v1H0v1h1v11a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V3h1V2zM4 1h5v1H4zm0 13H3V4h1zm3 0H6V4h1zm3 0H9V4h1z',
          onAction: () => {
            if (isChange && isChanged !== true) {
              return isImageInChange(isChange, false, lang);
            }

            this.startRendering();
            this.setDebounce();
            this.props.dispatch(imageChange(false));
            this.props.dispatch(removeImage(pageId, placeholderId));
          },
        },
      },
      {
        name: SvgIcon,
        title: 'Change image',
        props: {
          width: defaultSize.width,
          height: defaultSize.height,
          path: 'M11,5V0H6L8.15,2.15,0,10.29H0L.71,11,8.85,2.85Zm5,.71h0L15.29,5,7.15,13.15,5,11v5h5L7.85,13.85Z',
          onAction: () => {
            this.setState({
              isChange: true,
            });
            const currentIsCover = activePage.isCover;
            if (isImageInChange(isChange, currentIsCover, lang) || transformations.isFit) {
              return;
            }
            if (isFlyleaf(activePage) || activePage.isBabyPage) {
              this.props.dispatch(imageChange(true));
              return this.props.dispatch(removeImageFromFlyLeaf(pageId, placeholderId, image));
            }

            this.props.dispatch(removeChangedImage(pageId, placeholderImageId));
            this.props.dispatch(imageChange(true));
            this.props.dispatch(removeTextureImage(placeholderId));
            this.props.dispatch(removeDPIOverlay(placeholderId, false));
            this.props.dispatch(dpiResolution(placeholderId, false));
          },
        },
      },
 /*      {
        name: SvgIcon,
        title: 'Fit image',
        props: {
          width: defaultSize.width,
          height: defaultSize.height,
          path: 'M0 0v16h16V0zm15 15H1V9h5v2H4.5l2 2 2-2H7V9h2V7h2v1.5l2-2-2-2V6H9V1h6z',
          onAction: () => {
            if (!layoutplaceholders[placeholderId].imageObject || activePage.isCover) {
              return;
            }
            this.startRendering();
            this.setDebounce();
            const { bookSizes } = this.props.bookProperties;
            const fitSizes = getFitSize(height, width, transformations.rotate, layoutObject, bookSizes);

            if (transformations.isFit) {
              return this.props.dispatch(fitImage(placeholderId, false, fitSizes));
            }

            this.props.dispatch(fitImage(placeholderId, true, fitSizes));
          },
        },
      }, */
    ];
  }


  renderCanvas(placeholders) {
    if (!placeholders) {
      return;
    }

    return placeholders.map(this.renderTexture);
  }

  renderBackgroundPlaceholder(backgroundPlaceholders) {
    if (backgroundPlaceholders && Object.keys(backgroundPlaceholders).length === 0) {
      return;
    }

    return backgroundPlaceholders.map(this.renderSingleBackgroundPlaceholder);
  }

  renderSingleBackgroundPlaceholder = (texture) => {
    const {
      pages,
      layouts,
      bookProperties,
      isPreview,
    } = this.props;

    const activePage = GetActivePage(pages);
    const { layout } = activePage;

    const coverRatio = {
      width: layouts.byId[layout] ? layouts.byId[layout].width : 0,
      height: layouts.byId[layout] ? layouts.byId[layout].height : 0,
    };

    const ratio = getEditorRatio('.Editor', activePage, coverRatio, bookProperties.bookSizes);
    const StyleWidth = isPreview ? bookProperties.placeholderBorderSize * ratio : bookProperties.placeholderBorderSize / bookProperties.bookSizes.ratio;
    const shadow = {
      boxShadow: `0px 0px ${StyleWidth / 2}px ${StyleWidth / 2}px rgba(0, 0, 0, 0.2)`,
    };
    const placeholderstyle = Object.assign(calculateStyle(texture, ratio), shadow);

    return (
      <div
        key="background01"
        className="backgroundPlaceholder"
        style={placeholderstyle}
      />
    );
  }

  renderTexture = (texture, index) => {
    const {
      id,
      imageRatio,
    } = texture;

    const {
      pages,
      isChange,
      images,
      layouts,
      bookProperties,
      isPreview,
      backgroundType,
      lang,
    } = this.props;
    const activePage = GetActivePage(pages);
    const { layout } = activePage;

    const coverRatio = {
      width: layouts.byId[layout] ? layouts.byId[layout].width : 0,
      height: layouts.byId[layout] ? layouts.byId[layout].height : 0,
    };

    const ratio = getEditorRatio('.Editor', activePage, coverRatio, bookProperties.bookSizes);
    const placeholderstyle = calculcatePlaceholderStyle(texture, ratio);

    const getHoveredTexture = id;
    const hoveredplaceholderId = getHoveredTexture || 0;

    const pageId = activePage.id;
    const icons = this.getIcons(texture, pageId);
    const DPIResolution = false;

    const StyleWidth = isPreview ? bookProperties.placeholderBorderSize * ratio : bookProperties.placeholderBorderSize / bookProperties.bookSizes.ratio;
    const BorderStyle = calculateBorderStyle(texture, ratio, StyleWidth);
    const canvasOVerlayStyle = {
      display: this.state.visibleOverlay && this.state.targetId === id ? 'block' : 'none',
    };

    return (
      <div
        key={`wrap-${index}`}
      >
        <div
          className="canvasOverlay"
          style={canvasOVerlayStyle}
          onMouseOver={() => this.mouseEnter(id)}
          onFocus={() => this.mouseEnter(id)}
          onMouseMove={event => this.dragImage(event, id, true)}
          onMouseUp={event => this.dragImage(event, id, true, true)}
          onMouseLeave={event => this.leaveOverlay(event, id)}
          role="presentation"
          key={`overlay-${index}`}
        />
        <div className="canvasBorder" style={backgroundType === 'tematikus' ? BorderStyle : {}} />
        <div
          key={index}
          className="tools"
          onMouseOver={() => this.mouseEnter(id)}
          onFocus={() => this.mouseEnter(id)}
          style={calculateStyle(texture, ratio)}
        >
          <Toolbar
            icons={icons}
            placeholderId={hoveredplaceholderId}
            pageId={pageId}
            isCover={pages[pageId].isCover}
            isFrontFlyLeaf={pages[pageId].isFrontFlyLeaf}
            isBackFlyLeaf={pages[pageId].isBackFlyLeaf}
            droppedImagesLength={Object.keys(activePage.droppedImages).length}
            isAutofill={bookProperties.autofill}
            coverType={bookProperties.cover.type}
            isFit={texture.transformations.isFit}
            lang={lang}
          />
          <Texture
            layouts={this.props.layouts}
            texture={texture}
            style={placeholderstyle}
            ratio={ratio}
            droppedImages={activePage.droppedImages}
            activePageplaceholders={activePage.placeholders}
            placeholders={this.props.layoutplaceholders}
            isChange={isChange}
            pageId={pageId}
            pages={pages}
            images={images.byId}
            index={index}
            imageRatio={imageRatio}
            DPIResolution={DPIResolution}
            onMouseDown={event => this.dragImage(event, id, true, false, true)}
            onClick={this.deleteImage}
          />
        </div>
      </div>
    );
  }


  mouseEnter = (id) => {
    if (this.state.targetId !== id) {
      this.setState({
        targetId: id,
      });
    }
  }

  renderImages() {
    if (!this.state.drag && (!this.state.mousePressed || this.state.mousePressed === null)) {
      const canvas = document.querySelectorAll('canvas');
      if (canvas.length > 0 && canvas !== null) {
        Object.values(canvas).map((canvasNode) => {
          const placeholderId = canvasNode.getAttribute('data-placeholderid');
          this.setImageToCanvas(canvasNode, placeholderId);
        });
      }
    }
  }


  componentDidUpdate() {
    this.renderImages();
  }

  setDebounce = () => {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 1000);
  }

  loadImages(images) {
    const loadedImages = this.images;
    const promiseArray = images.map((imgurl) => {
      const prom = new Promise(((resolve) => {
        const img = new Image();
        img.onload = function () {
          loadedImages[imgurl] = img;
          resolve();
        };
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = imgurl;
      }));
      return prom;
    });

    return promiseArray;
  }

  dragImage = (event, id, mousePressed = null, isUp = false, mouseDown = false) => {
    const { clientX, clientY } = event;
    const {
      width,
      height,
      transformations,
      imageObject,
    } = this.props.layoutplaceholders[id];

    let { imageRatio } = this.props.layoutplaceholders[id];

    if (!imageObject || transformations.isFit) {
      return;
    }


    if (mousePressed !== null) {
      this.setState({
        mousePressed,
      });
    }

    if (mousePressed) {
      const canvas = document.querySelector(`.EditorInner canvas[data-placeholderid="${id}"]`);
      const canvasIndex = canvas.getAttribute('data-placeholderid');
      const scale = canvas.getAttribute('data-scale');

      if (mouseDown) {
        this.dragStartY = clientY;
        this.dragStartX = clientX;
      }

      const placeholderWidthRatio = transformations.fillSizes.width / width;
      const placeholderHeightRatio = transformations.fillSizes.height / height;


      if (this.state.targetId === id) {
        this.dragActions.mouseMove.x = (((clientX * placeholderWidthRatio) - this.dragStartX) * 2) / scale;
        this.dragActions.mouseMove.y = (((clientY * placeholderHeightRatio) - this.dragStartY) * 2) / scale;
      }
      this.setState({
        visibleOverlay: true,
      });

      if (isUp) {
        if (id && this.state.drag) {
          if (transformations.rotate === 90 || transformations.rotate === 270) {
            imageRatio = transformations.fillSizes.width / imageObject.originalHeight;
          }

          this.props.dispatch(moveImage(
            id,
            (this.dragActions.dragPosition.x * imageRatio) * scale,
            (this.dragActions.dragPosition.y * imageRatio) * scale,
          ));
          this.startRendering();
          this.setDebounce();
        }
        this.setState({
          visibleOverlay: false,
          targetId: 0,
          drag: false,
          mousePressed: null,
        });
      } else {
        this.setImageToCanvas(canvas, canvasIndex);
      }
    }
  }

  drawDraggedCanvas(src, context, canvasStyle, isFit, placeholderId) {
    const required = ['moveX', 'moveY', 'scaleX', 'angle'];
    const validProperties = required.every(element => Object.keys(canvasStyle).indexOf(element) > -1);
    if (!validProperties) {
      throw new Error('Missing object properties.');
    }

    let {
      moveX, moveY,
    } = canvasStyle;
    const { scaleX, angle } = canvasStyle;
    const mouseX = this.dragActions.mouseMove.x;
    const mouseY = this.dragActions.mouseMove.y;

    moveX > 0 ? moveX : mouseX;
    moveY > 0 ? moveY : mouseY;

    if (this.state.mousePressed) {
      if (!this.state.drag && this.state.targetId === parseInt(placeholderId, 10)) {
        this.dragActions.startPosition.x = mouseX - moveX;
        this.dragActions.startPosition.y = mouseY - moveY;
      }
      this.setState({
        drag: true,
      });
    }

    const placeholderData = this.props.layoutplaceholders[placeholderId];

    if (placeholderData === undefined) {
      return;
    }

    const originalImage = {
      width: placeholderData.imageObject.width,
      height: placeholderData.imageObject.height,
      scale: placeholderData.transformations.scaleX,
      fillSizes: placeholderData.transformations.fillSizes,
      placeholderWidth: placeholderData.width,
      placeholderHeight: placeholderData.height,
      imageRatio: placeholderData.imageRatio,
    };


    const thumbnailSize = {
      width: src.width,
      height: src.height,
    };

    const thumbnailRatio = originalImage.height / thumbnailSize.height;

    this.thumbnailRatio = thumbnailRatio;
    if (this.state.mousePressed && this.state.targetId === parseInt(placeholderId, 10)) {
      moveX = mouseX - this.dragActions.startPosition.x;
      moveY = mouseY - this.dragActions.startPosition.y;
      const drags = maximumDrag(angle, originalImage.height, originalImage.width, originalImage.fillSizes, originalImage.placeholderHeight, originalImage.placeholderWidth, originalImage.imageRatio);
      moveX = moveX > 0 ? 0 : (moveX >= -drags.moveX || moveX === 0) ? moveX : -drags.moveX;
      moveY = moveY > 0 ? 0 : (moveY >= -drags.moveY || moveY === 0) ? moveY : -drags.moveY;
      this.dragActions.dragPosition.x = (moveX / scaleX);
      this.dragActions.dragPosition.y = (moveY / scaleX);
    }

    isFit ? fit(context, src, angle) : fill(context, src, (moveX / thumbnailRatio), (moveY / thumbnailRatio), angle, scaleX, 0);
  }

  drawFillImage(ctx, imageRatio, angle, image, canvas, scaleX, scaleY, moveX, moveY, isFit, originalPlaceholderWidth, originalImageWidth, placeholderId) {
    const {
      lang,
      bookProperties,
    } = this.props;


    checkMinimumDPI(ctx, imageRatio, originalImageWidth, originalPlaceholderWidth, lang, bookProperties.bookSizes);
    ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2);
    ctx.rotate(angle);
    ctx.scale(scaleX, scaleY);
    ctx.translate(-ctx.canvas.width / 2, -ctx.canvas.height / 2);

    const canvasStyle = {
      moveX,
      moveY,
      scaleX,
      angle,
    };

    const degree = angle * (180 / Math.PI);

    if (degree === 0) {
      ctx.setTransform(scaleX, 0, 0, scaleX, 0, 0);
    }
    if (degree === 90) {
      ctx.setTransform(
        0,
        scaleX,
        -scaleX,
        0,
        ctx.canvas.width - (((ctx.canvas.width - ctx.canvas.height) / 2) * scaleX),
        -(((ctx.canvas.width - ctx.canvas.height) / 2) * scaleX),
      );
    }
    if (degree === 180) {
      ctx.setTransform(-scaleX, 0, 0, -scaleX, ctx.canvas.width, ctx.canvas.height);
    }
    if (degree === 270) {
      ctx.setTransform(
        0,
        -scaleX,
        scaleX,
        0,
        -(((ctx.canvas.height - ctx.canvas.width) / 2) * scaleX),
        ctx.canvas.height - (((ctx.canvas.height - ctx.canvas.width) / 2) * scaleX),
      );
    }


    this.drawDraggedCanvas(image, ctx, canvasStyle, isFit, placeholderId);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }

  startRendering = () => {
    this.setState({
      isChange: false,
    });
  }

  stopRendering = () => {
    const { isChange } = this.state;
    if (!isChange) {
      this.props.dispatch(saveState());
    }
  }

  leaveOverlay = (event, id) => {
    if (this.state.drag) {
      const { imageRatio } = this.props.layoutplaceholders[id];

      this.props.dispatch(moveImage(
        id,
        this.dragActions.dragPosition.x * imageRatio,
        this.dragActions.dragPosition.y * imageRatio,
      ));
    }

    this.setState({
      visibleOverlay: false,
      targetId: 0,
      drag: false,
      mousePressed: null,
    });
  }

  render() {
    const {
      placeholders,
      backgroundPlaceholders,
    } = this.props;
    return (
      <div>
        { this.renderCanvas(placeholders) }
        { backgroundPlaceholders && this.renderBackgroundPlaceholder(backgroundPlaceholders) }
      </div>
    );
  }
}

Canvas.defaultProps = {
  isChange: false,
  images: {},
  canvas: {},
  placeholders: [],
  bookProperties: {},
  layouts: {},
  width: 1400,
  height: 1400,
  transformations: {},
  imageObject: {},
  imagesLoaded: '',
  backgroundType: '',
  convertFinished: false,
  backgroundPlaceholders: [],
  isPreview: false,
};

Canvas.propTypes = {
  isChange: PropTypes.bool,
  images: PropTypes.object,
  canvas: PropTypes.object,
  placeholders: PropTypes.array,
  bookProperties: PropTypes.object,
  layouts: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  transformations: PropTypes.object,
  imageObject: PropTypes.object,
  imagesLoaded: PropTypes.string,
  backgroundType: PropTypes.string,
  convertFinished: PropTypes.bool,
  backgroundPlaceholders: PropTypes.array,
  isPreview: PropTypes.bool,
};

export default connect(state => ({
  canvas: state.editorUI.canvas,
  layoutplaceholders: state.entities.placeholders.byId,
  layouts: state.entities.layouts,
  images: state.entities.images,
  pages: state.entities.pages.byId,
  isChange: state.editorUI.imageChange.isChange,
  bookProperties: state.bookProperties,
  autofillFinished: state.entities.io.autofillFinished,
  convertFinished: state.entities.io.convertFinished,
  imagesLoaded: state.entities.io.imagesLoaded,
  backgroundType: state.editorUI.bookProperties.backgroundType,
}
))(Canvas);



// WEBPACK FOOTER //
// ./src/components/canvas/Canvas.jsx